import React from 'react';
import styled from 'styled-components';
import { colors } from '@/constants/colors';
import useAuthStore from '@/store/authStore';
import { useTeamStore } from '@/store/useTeamStore';
import {
   OverviewTab,
   Wrapper,
   useVendoData,
} from '@/pages/Admin/Vendo';
import VoucherStockBannerLive from '@/components/Admin/Home/VoucherStockBanner';

const WifiDashboard = () => {
   useVendoData();
   const { user } = useAuthStore();
   const acting = useTeamStore((s) => s.acting);
   // While helping, this is THEIR dashboard — greet the owner, not the helper.
   const displayName = acting
      ? acting.ownerName || acting.ownerEmail.split('@')[0]
      : user?.name || user?.email?.split('@')[0] || 'Guest';
   return (
      <Wrapper>
         <GreetingsWrapper>
            <Greetings>Welcome back</Greetings>
            <NameRow>
               <NameAvatar>{displayName.charAt(0).toUpperCase()}</NameAvatar>
               <NameText>{displayName}</NameText>
            </NameRow>
         </GreetingsWrapper>
         <VoucherStockBannerLive />
         <OverviewTab />
      </Wrapper>
   );
};

export default WifiDashboard;

const GreetingsWrapper = styled.div`
   margin-top: 1.5rem;
   margin-bottom: 1rem;
   padding: 0 1rem;
   @media (max-width: 768px) {
      margin-top: 12px;
      padding: 0 12px;
   }
`;

const Greetings = styled.p`
   font-size: 12px;
   font-weight: 600;
   text-transform: uppercase;
   letter-spacing: 0.06em;
   color: ${colors.GRAY5};
   margin: 0 0 6px;
`;

const NameRow = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
`;

const NameAvatar = styled.div`
   width: 38px;
   height: 38px;
   border-radius: 50%;
   background: ${colors.PRIMARY}18;
   color: ${colors.PRIMARY};
   display: inline-flex;
   align-items: center;
   justify-content: center;
   font-size: 16px;
   font-weight: 800;
   flex-shrink: 0;
`;

const NameText = styled.p`
   font-size: 22px;
   font-weight: 700;
   color: ${colors.GRAY1};
   margin: 0;
   letter-spacing: -0.01em;
   @media (max-width: 768px) {
      font-size: 18px;
   }
`;
